import { storeSelect, storeGetSetup } from "./store";
import { storeAvailabilityReset, bookingProcessSetDate } from "./bookingProcess";
import { apiAvailabilityReservation } from "../../api/apiAvailabilityReservation";

export const CHANGE_STORE_MODAL_OPEN = 'CHANGE_STORE_MODAL_OPEN';
export const changeStoreModalOpen = ({ isOpen = true, date, covers }) => ({ type: CHANGE_STORE_MODAL_OPEN, isOpen, date, covers });

export const CHANGE_STORE_MODAL_SET_STORES = 'CHANGE_STORE_MODAL_SET_STORES';
export const changeStoreModalSetStores = stores => ({ type: CHANGE_STORE_MODAL_SET_STORES, stores });

export const CHANGE_STORE_MODAL_IS_LOADING = 'CHANGE_STORE_MODAL_IS_LOADING';
const changeStoreModalSetIsLoading = isLoading => ({ type: CHANGE_STORE_MODAL_IS_LOADING, isLoading });

export const changeStoreModalStart = ({ covers, date }) => async (dispatch, getState) => {
    dispatch(changeStoreModalOpen({ isOpen: true, covers, date }));
    let response = {};
    try {
        response = await apiAvailabilityReservation({ date, covers });
    } catch (error) {
        return;
    }

    const lunchFromTime = new Date(`${date}T11:30`);
    const lunchToTime = new Date(`${date}T16:45`);
    const dinnerFromTime = new Date(`${date}T17:00`);
    const dinnerToTime = new Date(`${date}T24:00`);

    const state = getState();
    // Prendere dalle 17 alle 24 per la cena, dalle 11.30 alle 1645 per pranzo
    const country = state.storesReducer.selectedCountry;
    const isServiceSelectedEvening = state.bookingProcessReducer.isServiceSelectedEvening;
    let stores = response.data;
    if (country) {
        stores = response.data.filter(store => store.address.country === country.id);
    }

    stores = stores.map(store => 
        ({ 
            ...store, 
            datesAvailability: store.availability.map(availability => new Date(`${availability.date}T${availability.time}`)) 
        }))
        .filter(store => {
            if (isServiceSelectedEvening) {
                for (let availability of store.datesAvailability) {
                    if (availability <= dinnerToTime && availability >= dinnerFromTime) {
                        return true;
                    }
                }
                return false;
            } else {
                for (let availability of store.datesAvailability) {
                    if (availability <= lunchToTime && availability >= lunchFromTime) {
                        return true;
                    }
                }
                return false;
            }
        });

    dispatch(changeStoreModalSetStores(stores));
}

export const changeStoreModalSetStore = storeId => async (dispatch, getState) => {
    const state = getState();
    // Save the current selected date to use it later
    const currentSelectedDate = state.bookingProcessReducer.dateSelected;
    // Selects the new stores
    dispatch(storeSelect(storeId));
    // Reset the availability of the store to request new ones
    dispatch(storeAvailabilityReset());
    // Set loading indicator
    dispatch(changeStoreModalSetIsLoading(true));
    // Retrieve and update the store setup
    await dispatch(storeGetSetup(storeId));
    dispatch(changeStoreModalSetIsLoading(false));
    dispatch(changeStoreModalOpen({ isOpen: false }));
    await dispatch(bookingProcessSetDate(currentSelectedDate));
}


// WEBPACK FOOTER //
// ./src/store/actions/changeStoreModal.js